<template>
  <div>
    <div class="header_unit header_bg_white">
      <div class="header_box">
        <div class="menu_left">
          <router-link class="icn_back_black" :to="{ name: 'dashboardAlertList' , params: {startDate: this.startDate, endDate: this.endDate}} ">
            <p class="top_tit">＜戻る</p></router-link>
        </div>
        <div class="menu_center">
          <p v-if="alertId == 0" class="menu_center_tex_l top_tit">店舗別アラート数 月間推移（温湿度異常）</p>
          <p v-else-if="alertId == 1" class="menu_center_tex_l top_tit">店舗別アラート数 月間推移（通信異常）</p>
          <p v-else-if="alertId == 2" class="menu_center_tex_l top_tit">実施・未実施項目 月間推移 （毎日項目）</p>
          <p v-else class="menu_center_tex_l top_tit">実施・未実施項目 月間推移 （不定期項目）</p>
        </div>
      </div>
    </div>
    <div class="main_unit" v-if="!isInitLoading">
      <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
      <div v-if="validationMessage" class="mgt_20 mgb_20 mgl_20">
        <Message :validationMessage="validationMessage" />
      </div>
      <div v-if="apivalidationMessage" class="mgt_20 mgb_20 mgl_20">
        <Message :validationMessage="apivalidationMessage" />
      </div>
      <div v-if="reload" class="alert_implementation_content_box">
        <BarChart :chart-data="implementedData" :options="options" class="bar_box"></BarChart>
      </div>

    </div>
  </div>
</template>
<script>
import Message from '@/app/components/Message.vue'
import PulseLoader from '@/app/components/PulseLoader.vue'
import BarChart from '@/app/components/BarChart.vue'

export default {
  name: 'dashboardAlertListChart',
  components: {
    Message,
    PulseLoader,
    BarChart
  },
  props: {
    startDate: String,
    endDate: String,
  },
  computed:{
    brandPath: function () {
      return this.$store.getters['brand/path']
    },
    alertId: function () {
      return this.$store.getters['dashboard/selectedAlertId']
    },
  },
  data: function () {
    return {
      isInitLoading:false,
      validationMessage:"",
      apivalidationMessage:"",
      isLoading:false,
      aggregatedData: {},
      statusSelect:1,
      reload:true,
      implementedData: {
        labels: [],
        datasets:[
          {
            label:['対応'],
            backgroundColor: '#4472C4',
            data:[],
          },
          {
            label:['未対応'],
            backgroundColor: '#ED7D31',
            data:[],
          }
        ],
      },
      options: {
        title: {
          display: true,
          text: '',
          fontSize: 20,
          position: "bottom",
        },
        scales: {
          xAxes: [{
            stacked: true,
            scaleLabel: {
              display: true,
            },
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        },
        legend: {
          //凡例
          display: true,
          position: "bottom",
        },
        responsive:true,
        maintainAspectRatio:false,
      },
    }
  },
  created: function(){
    this.calc();
  },
  methods: {
    calc:async function() {
      this.isInitLoading = true;
      this.validationMessage = "";
      this.apivalidationMessage = "";

      // 企業ブランドIDの取得
      this.brandId = this.$store.getters['brand/id'];
      // 店舗IDの取得
      const storeId = this.$store.getters['store/selectedStoreId']
      var url = "";
      if (this.alertId == 0 || this.alertId == 1){
        url = this.$apiEndpoint + 'manage/brand/' + this.brandId + '/dashboard/alertList/monthlyChart/' + storeId;
        this.options.scales.yAxes[0].ticks.stepSize = 1;
      } else {
        url = this.$apiEndpoint + 'manage/brand/' + this.brandId + '/dashboard/alertList/dailyCheck/monthlyChart/' + storeId;
        this.options.scales.yAxes[0].ticks.stepSize = 10;
      }
      // DBデータ取得
      await this.$axios
          .get(url, { params: { alertId: this.alertId}})
          .then(response => {
            this.aggregatedData = response['data']['aggregatedData'];
            this.aggregatedData.forEach(item => {
              this.implementedData.labels.push(item.label);
              this.implementedData.datasets[0].data.push(item.implemented);
              this.implementedData.datasets[1].data.push(item.notImplemented);
            });
            this.options.title.text = "店舗名：".concat(response['data']['storeName']);
          })
          .catch((err) => {
            let error = {
              button: {
                path: {name: 'top', params: {brandPath: this.brandPath}}
              }
            }
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
          }).finally(() => this.isInitLoading = false);
    },
    async changeKbn() {
      // グラフ再描画の為、表示フラグをOFFにする
      this.reload = false;
      this.implementedData.datasets[0].data = [];
      this.implementedData.datasets[1].data = [];
      switch (this.statusSelect) {
        case '1':
          this.aggregatedData.forEach(item => {
            this.implementedData.datasets[0].data.push(item.implemented);
            this.implementedData.datasets[1].data.push(item.notImplemented);
          });
          break;
        case '2':
          this.aggregatedData.forEach(item => {
            this.implementedData.datasets[0].data.push(item.implementedUpperLower);
            this.implementedData.datasets[1].data.push(item.notImplementedUpperLower);
          });
          break;
        case '3':
          this.aggregatedData.forEach(item => {
            this.implementedData.datasets[0].data.push(item.implementedBatteryReceiveError);
            this.implementedData.datasets[1].data.push(item.notImplementedBatteryReceiveError);
          });
          break;
        default:
          break;
      }
      // 描画完了まで待機
      await this.$nextTick();
      // グラフ再描画の為、表示フラグをOFFにする
      this.reload = true;
    },
  }
}
</script>